import { DimensionUnits, WeightUnits } from '../../../../../shared/enums/enum';

export class PaginatedShipmentBoxResponse {
  totalCount: number = 0;
  pageNumber: number = 0;
  pageSize: number = 0;
  items: ShipmentBoxModel[] = [];
}

//Shipment Boxes Models
export class ShipmentBoxModel {
  id: number = 0;
  name: string = '';
  description: string = '';
  materialType: number = 0;
  sku: string = '';
  companyId: number = 0;
  height: number = 0;
  width: number = 0;
  length: number = 0;
  dimensionUnit: DimensionUnits = DimensionUnits.Unknown;
  tareWeight: number = 0;
  maxWeight: number = 0;
  weightUnit: WeightUnits = WeightUnits.Unknown;
  status: boolean = true;
  canIncludeOnScanSheet: boolean = false;
  customCategory: string[] = [];
  barcode: string = '';
  availableQuantity: number = 0;
  isDefault: boolean = false;
}
